<template>
  <b-modal
    :id="id"
    class="walletconnect-info zIndex-top"
    no-close-on-backdrop
    hide-header
    hide-footer
    centered
  >
    <div class="p-3">
      <header>
        <div class="d-flex flex-row justify-content-between">
          <h1 class="color-primary">
            <span>{{ $t("walletconnect.header.line1") }}</span> <br />
            <strong>{{ $t("walletconnect.header.line2") }}</strong>
          </h1>
          <button
            type="button"
            class="walletconnect-info__close"
            aria-label="Close"
            @click="hide"
          >
            <img src="@/assets/img/close.svg" alt="" />
          </button>
        </div>

        <p class="subtitle color-primary">
          {{ $t("walletconnect.header.description") }}
        </p>
      </header>

      <section class="how-it-works">
        <h2>{{ $t("walletconnect.how.title") }}</h2>
        <ul>
          <li>
            <span class="icon">🔐</span>
            <span
              class="color-primary"
              v-html="$t('walletconnect.how.step1')"
            ></span>
          </li>
          <li>
            <span class="icon">📲</span>
            <span class="color-primary">{{
              $t("walletconnect.how.step2")
            }}</span>
          </li>
          <li>
            <span class="icon">🛡️</span>
            <span class="color-primary">{{
              $t("walletconnect.how.step3")
            }}</span>
          </li>
          <li>
            <span class="icon">🚫</span>
            <span class="color-primary">{{
              $t("walletconnect.how.step4")
            }}</span>
          </li>
        </ul>
      </section>

      <section class="remember color-primary">
        <h2>{{ $t("walletconnect.remember.title") }}</h2>
        <p>
          <span class="icon">🧠</span> {{ $t("walletconnect.remember.text") }}
        </p>
      </section>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "WalletConnectInfoModal",
  props: {
    infoModal: Boolean,
  },

  data() {
    return {
      id: "walletConnectModal",
    };
  },
  watch: {
    infoModal: {
      handler(val) {
        if (val) {
          this.show();
        } else {
          this.hide();
        }
      },
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
      this.$emit("handleShowChange", true);
    },
    hide() {
      this.$bvModal.hide(this.id);
      this.$emit("handleShowChange", false);
    },
  },
};
// No logic needed
</script>

<style scoped>
.walletconnect-info {
  max-width: 480px;
  margin: 2rem auto;
  padding: 1.5rem;
  font-family: "Inter", sans-serif;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.walletconnect-info__close {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0;
  margin: -4px -4px 0 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  transition: background 0.2s ease;

  img {
    width: 10px;
    height: 10px;
    display: block;
  }

  &:hover {
    background: #f0f0f0;
  }

  &:focus-visible {
    outline: 2px solid #5559fe;
    outline-offset: 2px;
  }
}

header h1 {
  font-size: 1.5rem !important;
  margin-bottom: 0.5rem;
  line-height: 1.3;
  padding-right: 8px;
}

header h1 span {
  font-weight: 400;
}

.subtitle {
  font-size: 0.875rem;
  color: #333;
  margin-bottom: 1.5rem;
}

.how-it-works h2,
.remember h2 {
  font-size: 1.35rem;
  color: #f26522;
  border-top: 2px solid #f26522;
  padding-top: 0.8rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

ul {
  list-style: none;
  padding-left: 0;
}

ul li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.4;
}

.icon {
  font-size: 1.05rem;
  min-width: 1.5rem;
}

.color-primary {
  color: #4539e4;
  font-size: 14px;
}
</style>
